import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Member } from 'src/app/model/member.model';
import { ReservationService } from './reservation.service';
import { DateService } from 'src/app/core/service/date.service';
import { AuthenticationService } from 'src/app/core/service/authentication.service';
import { SelectItem } from 'primeng/api';
import {
  ReservationSign,
  ResPeriodStatus
} from 'src/app/model/resPeriodStatus.model';
import { BehaviorSubject, catchError, map, Observable, of, Subscription } from 'rxjs';
import { OptionListService } from 'src/app/core/service/optionList.service';
import Swal from 'sweetalert2';
import liff from '@line/liff';
import { SelectedItemService } from 'src/app/core/service/selected-item.service';
import { CheckStatus, ServiceItem } from 'src/app/model/reservation.model';
import { NgxSignaturePadComponent, NgxSignatureOptions } from '@eve-sama/ngx-signature-pad';
import { ScrollPanel } from 'primeng/scrollpanel';
@Component({
  selector: 'app-reservation',
  templateUrl: './reservation.component.html',
  styleUrls: ['./reservation.component.css'],
})
export class ReservationComponent implements OnInit {
  @ViewChild('sig', { static: false }) pad!: NgxSignaturePadComponent;
    options: NgxSignatureOptions = {
      backgroundColor: '#fff',
      width: 500,
      height: 300
    };
  /** 同意書Scroll */
  @ViewChild('consentFormScrollPanel') public scrollPanel: ScrollPanel;
  /**===訂閱管理=== */
  private subscribes: Subscription = new Subscription();
  private periodSubscription?: Subscription;

  /**===狀態控制=== */
  Step: number = 1;
  isLoading: boolean = false;
  isOptionLoading: boolean = false;
  /** 是否已閱讀完同意書(滾動至最底) */
  isConsentFormRead: boolean = false;
  isScrollBottom = false;
  isFinalLoading: boolean = false;
  isSelectedStore: boolean = false; //有選門市才可開放選時段
  isNew: boolean = false;
  isAgreed = false;

  /**===資料模型=== */
  /**表單內容 */
  model: any = {}; 
  /**預覽表單 */
  editModel: any = {}; 
  /**同意書簽名model */
  drawData: ReservationSign;

  /**===門市預約相關=== */
  StoreList: any[] = [];
  StoreSelectList: SelectItem[] | null = null;
  PetList: any[] = [];
  PetSelectList: SelectItem[] | null = null;
  /**服務項目列表 */
  ServiceItemList: any[] = []; 
  ServiceItemSelectList: ServiceItem[]=[];
  /**門市營業時段列表 */
  storeOpenTimeList: SelectItem[] = []; 
  /**已預約時段列表 */
  occupiedPeriodList: ResPeriodStatus[] = []; 
  setServiceList: string[] = [];

  /**===參數=== */
  CompanyID: string = '';
  UserID: string = '';
  Liff_ID: string = '';
  /**每個時段最多可預約人數(預設1人)) */
  MaxPeople: number = 1;
  TotalPrice: number = 0;
  TotalTimes: number = 0;
  /**紀錄所選取服務 */
  selectedServices: string = "";
  ErrorMsg_openTime: string = ""; //開放時間的訊息
  ErrorMsg: string = "";

  UserName: string;
  LoginUser: Member;
  /**選取的門市 */
  selectStore: any = {}; 
  /**服務金額提醒 */
  RemindStr: string;
  /**休假日設定 */
  storeSchedules: any[] = []; 
  /**特殊休假日 */
  storeUnSchedules: any[] = []; 
  /**目前可預約日期 */
  resMinDate: Date; 
  /**每周休假日 */
  disabledDays: any[] = []; 
  /**特殊休假日 */
  disabledDates: any[] = []; 
  /**取得參數檔中的【服務最後可預約時間】 */
  FinalResParam: string = ''; 
   /**取得參數檔中的【Line美容預約是否顯示時段】 */
  ShowOrNotParam: string = ''; 
  /**取得代碼檔中的【Line訊息】 */
  LineMsg: string = ''; 
  nowTime: string = '';
  nowDate: string = '';
  /** 同意書內容 */
  public consentFormContent: string;
  constructor(
    private route: ActivatedRoute,
    private ReservationService: ReservationService,
    private DateService: DateService,
    private authenticationService: AuthenticationService,
    private OptionListService: OptionListService,
    private router: Router,
    private SelectedItemService: SelectedItemService
  ) {}

  ngOnInit(): void {
    // 取得querystring param
    var query = this.route.queryParams.subscribe((value) => {
      this.CompanyID = value['CompanyID'];
      this.UserID = value['UserID'];
      this.Liff_ID = value['Liff_ID'];
    });

    var currentUser = this.authenticationService.currentMember.subscribe(
      (member) => {
        this.LoginUser = member;
      }
    );

    this.subscribes.add(query);
    this.subscribes.add(currentUser);
    this.clearAll();
    
    this.subscribes.add(
      this.subscription().subscribe((isFinished) => {
        if (!isFinished) return;
      })
    );
  }
  ngAfterViewInit() {
    this.setupScrollListener();
    if (!this.scrollPanel?.contentViewChild) return; // 避免 undefined

    this.scrollPanel.contentViewChild.nativeElement.addEventListener(
      'scroll',
      this.onCheckSignatureAndReadConsentForm.bind(this)
    );
  }

  private setupScrollListener() {
    if (!this.scrollPanel?.contentViewChild) return;
    // 先移除舊的，避免重複綁定
    const el = this.scrollPanel.contentViewChild.nativeElement;
    el.removeEventListener('scroll', this.onCheckScroll); 
    el.addEventListener('scroll', this.onCheckScroll.bind(this));
  }
  private onCheckScroll(event: any) {
    const el = event.target;
    // 判斷是否滑動到底部 (誤差 5px 以內)
    const isBottom = el.scrollHeight - el.scrollTop - el.clientHeight <= 5;
    if (isBottom) {
      this.isConsentFormRead = true;
      this.isScrollBottom = true;
    }
  }
  //#region  初始化設定

  /**預設值設定*/
  setDefaultValue() {
    this.model.ResDate = this.getResMinDate();

    this.setStoreOpenTime();
    
    if (this.storeOpenTimeList && this.storeOpenTimeList.length > 0) {
      this.model.ExpectedTime = this.storeOpenTimeList[0].value;
    }
  }
  /**取得門市與服務項目 */
  subscription(): Observable<boolean> {
    this.isOptionLoading = true;
    
    return this.ReservationService.GetDefaultData(this.CompanyID, this.UserID).pipe(
      map((res: any) => {
        if (res['ErrorFlag'] === "1") {
          this.handleError("您目前無法進行預約，請聯絡該門市，謝謝。", true);
          return false;
        }
        if (!res['Stores']) {
          this.handleError(res.ErrorMsg || "載入失敗");
          return false;
        }
        this.getDataSucceed(res);
        return true;
      }),
      catchError((err: any) => {
        this.handleError("連線異常，請稍後再試");
        return of(false);
      })
    );
  }

  //#endregion

  //#region 按鈕事件
  selectTime(value: any) {
    this.model.ExpectedTime = value;
    this.ChangeExpectedTime(); // 保留你原本的動作
  }
  /**修改預約時段*/
  ChangeExpectedTime() {
    this.clearSearchResult();
    
    //檢查服務時段中是否有其他服務預約
    if(this.occupiedPeriodList.length>0) this.CheckTimeTo();
  }
  /**檢查服務時段中是否有其他服務預約 */
  CheckTimeTo(){
    const result = [];
    const start = parseTime(this.model.ExpectedTime);
    const end = parseTime(this.DateService.AddMinutes(this.model.ExpectedTime, this.TotalTimes));
    
    /**轉換時間字串 */
    function parseTime(time: string)
    {
      const [hours, minutes] = time.split(":").map(Number);
      const date = new Date();
      date.setHours(hours, minutes, 0, 0);
      return date;
    }
    /**轉換Date */
    function formatTime(time: Date)
    {
      const hours = String(time.getHours()).padStart(2, "0");
      const minutes = String(time.getMinutes()).padStart(2, "0");
      return `${hours}:${minutes}`;
    }
    
    // 建立時段對應表，提高查詢效率
    const occupiedMap = new Map(this.occupiedPeriodList.map(item => [item.Period, item]));  
    let currentTime = new Date(start);  
    // 不限制無縫接軌狀況，所以currentTime < end
    while (currentTime < end) {
        const period = formatTime(currentTime);
        const occupied = occupiedMap.get(period);
        
        if(occupied && occupied.Count !== undefined && occupied.Count >= this.MaxPeople)
        {
          result.push(occupied);
        }
        currentTime.setMinutes(currentTime.getMinutes() + 30);
    }
   
    this.ErrorMsg = result.length
    ? result.map(s => `${s.Period}時段預約已客滿`).join("，")
    : "";
  }
  /**選取門市後取得相應營業時間*/
  ChooseStore() {
    this.clearSearchResult();
    var storeNo = this.model.StoreNo;
    this.isSelectedStore = !!storeNo;
    if (!!storeNo) {
      this.selectStore = this.StoreList.find((s) => s.StoreNo == storeNo);
      if (!this.selectStore) return;
      this.MaxPeople = this.selectStore.MaxPeople??1;
      this.setDisabledDate();
      const minDateStr = this.getResMinDate();
      this.resMinDate = new Date(minDateStr);

      this.model.ResDate = this.DateService.DateToString(
        this.resMinDate,
        'yyyy-mm-dd'
      );
      //取得該門市的營業時間
      this.setStoreOpenTime();
      
      if (this.storeOpenTimeList && this.storeOpenTimeList.length > 0) {
        this.model.ExpectedTime = this.storeOpenTimeList[0].value;
        this.ErrorMsg_openTime = ""; // 清除可能的錯誤訊息
      } else {
        this.model.ExpectedTime = null;
        this.ErrorMsg_openTime = "本日門市預約已過營業時間，請選擇其他日期。";
        // 選用動作：自動幫使用者跳到明天
        // this.switchToNextAvailableDay(); 
      }
      //查詢各時段預約狀況
      this.SearchPeriod();
    }else{
      this.TotalPrice = 0;
      this.setServiceList = [];
      this.ErrorMsg = "";
      this.disabledDays = [];
      this.disabledDates = [];
      this.storeOpenTimeList = [];
      this.occupiedPeriodList = [];
      this.resetServiceList();
    }
  }
  /**選取預約日期*/
  changeResDate() { 
    if(!!this.model.StoreNo){
      this.clearSearchResult();
      if (this.model.ResDate instanceof Date) {
        this.model.ResDate = this.DateService.DateToString(
          this.model.ResDate,
          'yyyy-mm-dd'
        );
      }
      this.model.ExpectedTime = ""; //記得重制時間
      this.SearchPeriod();
    }
    
  }

  /**時段搜尋*/
  SearchPeriod(){
    this.isLoading = true;
    this.clearSearchResult();
    // 如果已經有正在進行的請求，先取消它
    if (this.periodSubscription) {
      this.periodSubscription.unsubscribe();
    }
    this.model.CompanyID = this.CompanyID;

    this.periodSubscription = this.ReservationService.GetReserved(this.model).subscribe({
      next: (result) => {
        this.getReservedSucceed(result);
        this.isLoading = false;
      },
      error: (err) => {
        console.error(err);
        this.isLoading = false;
      }
    });

    this.subscribes.add(this.periodSubscription);
  }

  /**選擇服務項目*/
  SelectServices() {
    if (!this.model.ReserveItems || this.model.ReserveItems.length === 0) {
      this.TotalPrice = 0;
      this.TotalTimes = 0;
      this.selectedServices = "";
      return;
    }
    this.TotalPrice = 0;
    this.TotalTimes = 0;
    const serviceNames: string[] = [];
    this.model.ReserveItems.forEach((el: any) => {
      const service = this.ServiceItemList.find(s => s.ChNo === el);
      if (!service) return;
      const price = Number(service.ChValue1) || 0;
      const time = Number(service.ChValue2) || 30;
      this.TotalTimes += time;
      this.TotalPrice += price;
      serviceNames.push(service.ChName);
    }); 
    this.selectedServices = serviceNames.join("，");
  }
  /**重置服務項目 */
  resetServiceList(){
      this.ServiceItemSelectList = this.ServiceItemList.map(item=>({
        Service: item.ChName, Status: CheckStatus.Unchecked,
        Icon: "pi pi-circle-off", Disabled: false, Class: "secondary"
      }));
      
      this.setServiceList = [];
  }
  async nextStep(step: number) {
    this.isLoading = true;
    switch (step) {
      case 0: // 同意書階段
        if (this.pad.isEmpty()) {
          alert('請先簽名');
          this.isLoading = false;
          return;
        }
        if(!this.isAgreed){
          this.handleError('請先勾選同意條款');
          this.isLoading = false;
          return;
        }
        this.drawData.SignPath = this.pad.toDataURL();  
        //最後記得清除
        this.pad.clear(); 
        this.ReservationService.SaveSign(this.drawData).subscribe(res=>{
          this.isLoading = false;  
          if (res.ErrorFlag === '1') {
            this.handleError(res.ErrorMsg);
          } else {
            this.pad.clear();
            this.Step++;
          }
        });
        break;
      case 1: // 選擇門市、寵物、服務
        // 下一步前先重制
        this.ErrorMsg = "";
        this.resMinDate = new Date(this.getResMinDate());

        this.model.ResDate = this.DateService.DateToString(
          this.resMinDate,
          'yyyy-mm-dd'
        ); 
        // 等待 SearchPeriod 完成
        await this.SearchPeriod();
        this.updateExpectedTimeAfterStep1();
        this.Step++;
        this.isLoading = false;
        break;
      case 2: // 選擇日期時間
        // 檢查所選時段是否有其他服務佔據
        if(!this.CheckOccupied())
        {
          this.handleError(this.ErrorMsg);
          this.isLoading = false;
          return ;
        }
        this.prepareEditModel();
        this.Step++;
        this.isLoading = false;
        break;
      case 3: // 最後確認介面
        this.Step++;
        //結果預覽
        this.isFinalLoading = true;
        
        var CreateReservation = this.ReservationService.CreateReservation(
          this.editModel
        ).subscribe((result) => this.CreateReserveSucceed(result));
        this.subscribes.add(CreateReservation);
        break;
      case 4: // 完成頁面
        //完成
        this.clearAll();
        
        // 1. 如果有預設門市，先填回去 (通常是 StoreList[0])
        if (this.StoreList && this.StoreList.length > 0) {
          this.model.StoreNo = this.StoreList[0].StoreNo;
          // 2. 重新觸發一次 ChooseStore 以便初始化日期、禁用日、時段清單
          this.ChooseStore(); 
        } else {
          // 如果連清單都沒了，可能需要重新呼叫 GetDefaultData (但不建議，應保留清單)
          this.subscription().subscribe();
        }
        this.Step = 1;
        this.isLoading = false;
        break;
      default:
        break;
    }
  }
  /**檢查預約狀況 */
  private updateExpectedTimeAfterStep1() {
    if (this.storeOpenTimeList.length === 0) {
      this.ErrorMsg_openTime = "本日預約已客滿";
      const origStoreOpenList = this.OptionListService.ExpandBetweenHHMM(
        this.selectStore.OpenTimeFrom, this.selectStore.OpenTimeTo
      );
      this.model.ExpectedTime = origStoreOpenList[0]?.value;
    } else {
      this.model.ExpectedTime = this.storeOpenTimeList[0].value;
      this.ErrorMsg_openTime = "";
    }
    //檢查預約時段中是否有已占位狀況
    if (this.occupiedPeriodList.length > 0) this.CheckTimeTo();
  }
  /**產生編輯資料 */
  private prepareEditModel() {
    const store = this.StoreList.find(s => s.StoreNo === this.model.StoreNo);
    const pet = this.PetList.find(s => s.PetNo === this.model.PetNo);
    
    this.editModel = {
      ...this.model,
      CompanyID: this.CompanyID,
      LineID: this.UserID,
      StoreName: store?.StoreName || '',
      PetName: pet ? `${pet.PetName}(${pet.VarietyName})` : '',
      ResTimeFrom: (this.ShowOrNotParam === "1") ? this.model.ExpectedTime : "",
      ResTimeTo: (this.ShowOrNotParam === "1") ? this.DateService.AddMinutes(this.model.ExpectedTime, this.TotalTimes) : "",
      Price: this.TotalPrice,
      Services: this.selectedServices
    };
  }
  /**清除所有暫存資料 */
  clearAll() {
    this.editModel = {};
    this.model = {
      ResDate: '',
      StoreNo: '',
      PetNo: '',
      ReserveItems: [],
      ExpectedTime: ''
    };
    this.TotalPrice = 0;
    this.setServiceList = [];
    this.ErrorMsg = "";
    this.storeOpenTimeList = []; 
    this.occupiedPeriodList = [];
    this.resetServiceList();
  }
  /**上一步 */
  prevStep() {
    this.Step--;
  }
  //#endregion

  //#region 相關事件

  /**清除搜尋結果 */ 
  clearSearchResult() {
    this.editModel.ResDate = '';
    this.editModel.ResTimeFrom = '';
    this.editModel.StoreName = '';
  }
  /**取得初始化資料 */
  getDataSucceed(res: any) {
    this.nowDate = this.DateService.GetToday();
    this.nowTime = this.DateService.GetNowTime();
    if(res.ErrorFlag == '1')
    {
      this.handleError(res.ErrorMsg);
      return;
    }
    // 載入休假日與參數 (這是 getResMinDate 的依賴項)
    this.storeSchedules = res['Schedules'];
    this.storeUnSchedules = res['UnSchedules'];
    this.FinalResParam = res['FinalResParam']?.ParameterValue || "0.5";
    this.ShowOrNotParam = res['ShowOrNotParam']?.ParameterValue || "1";

    this.StoreList = res['Stores'];
    this.StoreSelectList = this.SelectedItemService.convertToSelectItem(
      res['Stores'],
      'StoreNo',
      'StoreName'
    );
    if (this.StoreList.length == 0) {
      this.handleError('尚未建立門市');
      return;
    }
    //預設門市
    this.selectStore = this.StoreList[0]; 
    this.model.StoreNo = this.selectStore.StoreNo;
    this.MaxPeople = this.selectStore.MaxPeople??1;
    
    // 先設定禁用日期陣列
    this.setDisabledDate();
    // 再設定預設日期與時間 (原本的 setDefaultValue 內容)
    this.setDefaultValue();
    this.ChooseStore();
    this.PetList = res['Pets'];
    this.PetSelectList = this.SelectedItemService.convertToSelectItem(
      res['Pets'],
      'PetNo',
      'PetName'
    );
    this.ServiceItemList = res['Items']; 
    if(!!this.ServiceItemList) this.resetServiceList();
    this.RemindStr = res["PriceRemind"];
    this.LineMsg = res['LineMsg'];
    //如果是首次使用要填寫同意書
    this.isNew = res['isNew']; 
    this.consentFormContent = "";
    if(this.isNew){
        this.Step = 0;
        this.drawData = new ReservationSign();
        this.drawData.CompanyID = this.CompanyID;
        this.drawData.UserID = this.UserID;
        this.isConsentFormRead = false;
        this.ReservationService.GetConsentForm(this.CompanyID).subscribe((result: any)=>{
          if (result?.ErrorFlag === '1'){
            this.handleError('錯誤資訊：' + result.ErrorMsg);
            
            return;
          }
          const currentDate = new Date().toLocaleDateString();
          this.consentFormContent = result.replace(/(日期)([:：]?\s*)(.*?)(\r?\n|$)/, `$1: ${currentDate}`);
          if (this.pad) {
            if (!this.scrollPanel?.contentViewChild) return;
             // 當有開啟簽名板時，檢查是否有閱讀完同意書，再開啟確認按鈕
             this.scrollPanel.contentViewChild.nativeElement.addEventListener('scroll', this.onCheckSignatureAndReadConsentForm.bind(this));
          }   
        });
    }
    this.isOptionLoading = false;
  }
  /** 檢查是否簽名並且閱讀同意書 */
  private onCheckSignatureAndReadConsentForm(event: Event) {
    if (!this.scrollPanel?.contentViewChild) return;
      const scrollElement = this.scrollPanel.contentViewChild.nativeElement;
      // 計算是否滾動到底部
      const isScrollToBottom = scrollElement.scrollHeight - scrollElement.scrollTop - scrollElement.clientHeight <= 1; // 誤差值 1
      this.isConsentFormRead = isScrollToBottom;
      if(this.isConsentFormRead)
        this.isScrollBottom = true;
  }

  getReservedSucceed(result: any) {
    
    var that = this;
    function copySearchToEdit() {
      that.editModel = {
        ...that.editModel,
        ...that.model,
      };
    }
    this.GetOccupiedPeriodList(result);
    this.setStoreOpenTime();
    //產生可預約時段的下拉選單
    this.GeneratestoreOpenTimeList();
    this.isLoading = false;

    copySearchToEdit();
  }
  /**取得可預約時段 */ 
  GeneratestoreOpenTimeList() {
    // 防止使用舊資料時段
    if (this.model.ResDate !== this.nowDate) {
      this.model.ExpectedTime = "";
    }
    var diff = (Number)(this.FinalResParam) * 2; 
    var lastResTime: number | null = null;
    this.ErrorMsg = "";
    // 需判斷當下時間是否開放預約
    if(diff > this.storeOpenTimeList.length){
      //該門市的營業時間
      var origStoreOpenList = this.OptionListService.ExpandBetweenHHMM(
        this.selectStore.OpenTimeFrom,
        this.selectStore.OpenTimeTo
      );
      lastResTime = origStoreOpenList[origStoreOpenList.length - diff].value;
      this.model.ExpectedTime = "";
      this.ErrorMsg_openTime = "預約只開放到" + lastResTime;
    }else{
      lastResTime = this.storeOpenTimeList[this.storeOpenTimeList.length - diff].value;
      this.ErrorMsg_openTime = "";
      var occupied = this.occupiedPeriodList.filter(s=>s.Status == 'F');
      if(lastResTime !== null)
      {
        const safeLastResTime = lastResTime;
        if (!!this.model.ResDate && this.model.ResDate == this.nowDate)
        {
          this.storeOpenTimeList = this.storeOpenTimeList.filter(
            (x) => x.value >= this.model.ExpectedTime && x.value <= safeLastResTime && !occupied.some(y=>y.Period == x.value)
          );
        }else{
          this.storeOpenTimeList = this.storeOpenTimeList.filter(
            (x) => x.value <= safeLastResTime && !occupied.some(y=>y.Period == x.value)
          );
        }    
      }
      //全部時段已客滿
      if(this.storeOpenTimeList.length == 0) 
      {
        this.model.ExpectedTime = "";
        this.ErrorMsg = "目前預約已客滿";
      } 
    }
  }

  /**預約結果 */ 
  async CreateReserveSucceed(result: any) {
    this.isFinalLoading = false;
    this.isLoading = false;
    this.UserName = result['MemberName'];
    var timeStr = (this.ShowOrNotParam == '1') 
                ? this.editModel.ResTimeFrom + '~' +  this.editModel.ResTimeTo 
                : this.LineMsg;
   
    try {
      await liff.init({ liffId: this.Liff_ID });
      
      if (!liff.isInClient()) {
            this.handleError('請從 LINE 聊天中開啟此頁面才能發送訊息');
            return;
      }
      const lines: (string | undefined)[] = [
            '預約成功，以下為預約資訊：',
            this.editModel.ResDate ? `預約日期： ${this.editModel.ResDate}` : undefined,
            this.editModel.StoreName ? `門市： ${this.editModel.StoreName}` : undefined,
            this.editModel.PetName ? `寵物： ${this.editModel.PetName}` : undefined,
            this.editModel.Services ? `預約服務： ${this.editModel.Services}` : undefined,
            timeStr ? `預約時段： ${timeStr}` : undefined,
            this.editModel.Price ? `預計費用： ${this.editModel.Price}` : undefined,
            this.RemindStr ? this.RemindStr : undefined
      ];
      const safeLines: string[] = lines.filter((x): x is string => !!x);

      const content = safeLines.join('\n');

      // 發送訊息
      await liff.sendMessages([{ type: 'text', text: content}]);

    }catch(err: any){
      this.handleError(err.message || '未知錯誤');
    }
    
  }
  /**檢查預約狀況 */
  CheckOccupied(){
    this.CheckTimeTo();
    return this.ErrorMsg == '';
  }
  //#endregion

  //#region 基本設定

  /**設置門市營業時間 */ 
  setStoreOpenTime() {
    if (!this.selectStore) return;
    let periods =this.OptionListService.ExpandBetweenHHMM(
      this.selectStore.OpenTimeFrom,
      this.selectStore.OpenTimeTo
    );
   
    //預設日期若為今天，可預約時段僅會出現目前時間之後的時段
    if (this.model.ResDate && this.model.ResDate == this.nowDate) {
      periods = periods.filter((x) => x.value >= this.nowTime);
    } 
    this.storeOpenTimeList = periods;
  }

  /** 取得目前可預約日期 */
  getResMinDate(): string {
    var that = this;
    /**檢查是否為休假日 */
    const isDateDisabled = (date: Date) => {
      const checkTime = new Date(date).setHours(0, 0, 0, 0);
     
      // 檢查固定周休
      const isFixed = that.disabledDays.includes(new Date(checkTime).getDay());
      
      // 檢查特殊休假 (比對毫秒數)
      const isSpecial = that.disabledDates.some(d => d.getTime() === checkTime);

      return isFixed || isSpecial;
    }
    let thisDate = new Date(this.nowDate);
    thisDate.setHours(0, 0, 0, 0);

    // 如果過營業時間，先加一天
    if (this.nowTime >= this.selectStore.OpenTimeTo) {
      thisDate.setDate(thisDate.getDate() + 1);
    }

    // 尋找下一個非休假日
    while (isDateDisabled(thisDate)) {
      thisDate.setDate(thisDate.getDate() + 1);
    }

    return this.DateService.DateToString(thisDate, 'yyyy-mm-dd');
  }
  /**設定休假日 */ 
  setDisabledDate() {
    if (!this.selectStore || !this.selectStore.StoreNo) return;
    // 1. 固定周休 (DateSerial 7 轉 0)
    const schedule = this.storeSchedules.filter(x => 
      x.StoreNo == this.selectStore.StoreNo
    );
    this.disabledDays = [...schedule.map(x => x.DateSerial === 7 ? 0 : x.DateSerial)];

    // 2. 特殊休假
    const unSchedule = this.storeUnSchedules.filter(x => 
      x.StoreNo == this.selectStore.StoreNo
    );
    const dateArr: Date[] = [];

    unSchedule.forEach(period => {
      let curr = this.parseLocalDate(period.DateS);
      let end = this.parseLocalDate(period.DateE);
      
      while (curr <= end) {
        dateArr.push(new Date(curr));
        curr.setDate(curr.getDate() + 1);
      }
    });
    
    this.disabledDates = [...dateArr];
  }
  /** 輔助方法：確保字串正確轉為在地時間凌晨的 Date 物件 */
  private parseLocalDate(dateStr: string): Date {
    const d = new Date(dateStr);
    // 如果字串只有 yyyy-mm-dd，new Date 可能會變成 UTC 0點（台灣早上8點）
    // 強制設定在地時間的 00:00:00
    d.setHours(0, 0, 0, 0);
    return d;
  }
  /**取得已預約時段清單 */ 
  GetOccupiedPeriodList(reservedList: any) {
    var that = this;
    
    function expandAllPeriod(reservedList: any[]) {
      var result = [] as any[];
      reservedList.forEach((res) => {
        result = result.concat(
          that.OptionListService.ExpandBetweenHHMM(
            res.TimeFrom,
            res.TimeTo
          )
        );
      });
      
      return result;
    }

    if (reservedList == null || reservedList.length == 0) {
      this.occupiedPeriodList = [];
    }

    var result: any[] = [];
    var maxPeopleCount = this.MaxPeople;
    
    var expandedPeriod = expandAllPeriod(reservedList);
    
    expandedPeriod.filter(function (value, index, self) { 
      var existIndex = result.findIndex((x) => x.Period == value.value);
      
      if (existIndex >= 0) {
        result[existIndex].Count += 1;
      } else {
        result.push({ Period: value.value, Count: 1 });
        existIndex = result.length - 1;
      }
      
      if (result[existIndex].Count >= maxPeopleCount) {
        result[existIndex].Status = 'F';
      }
    });
    
    this.occupiedPeriodList = result.sort(); 
  }

  onSetService(index: number){
    let getNo = this.ServiceItemList[index].ChNo;
    if(this.setServiceList.some(s=>s == getNo))
    {
      let serviceList = this.ServiceItemSelectList[index];
      serviceList.Status = CheckStatus.Unchecked;
      serviceList.Icon = "pi pi-circle-off";
      serviceList.Disabled = false;
      serviceList.Class = "secondary";
      this.setServiceList = this.setServiceList.filter(s=>s != getNo);
    }else{
      let serviceList = this.ServiceItemSelectList[index];
      serviceList.Status = CheckStatus.Checked;
      serviceList.Icon = "pi pi-check";
      serviceList.Disabled = false;
      serviceList.Class = "";

      this.setServiceList.push(getNo);
    }
    this.model.ReserveItems = this.setServiceList;
    this.SelectServices();
  }
  /**清除簽名
    */
  clear() {
      this.pad.clear();
      this.isAgreed = false;
  }
  onBegin() { /* 開始簽名事件 */ }
  onEnd() { /* 結束簽名事件 */ }

  /**確認表單填寫完畢 */ 
  isFirstStepFinish() {
    const hasDate = !!this.editModel.ResDate;

    if (this.ShowOrNotParam === '1') {
      return hasDate &&
            !!this.editModel.ResTimeFrom &&
            !!this.editModel.ResTimeTo;
    }

    return hasDate;
  }
  /**送出前驗證 */
  EditRequired(){
    const hasRequiredFields = !!this.model.StoreNo &&
                            !!this.model.PetNo &&
                            !!this.model.ResDate &&
                            !!this.model.ReserveItems &&
                            this.model.ReserveItems.length > 0 && !!this.model.ExpectedTime && this.ErrorMsg_openTime == '';

    if (!hasRequiredFields) return false;
    var result = !!this.ErrorMsg == false || this.ErrorMsg != "目前預約已客滿"; 
    return this.ShowOrNotParam === '1'
      ? result
      : this.storeOpenTimeList.length !== 0;
  }
  Step1Required(){
    return !!this.model.StoreNo && !!this.model.PetNo && !!this.setServiceList && this.setServiceList.length>0;
  }

  CheckDateOpen(){
    return !!this.model.StoreNo && !!this.model.PetNo && !!this.model.ReserveItems && this.model.ReserveItems.length>0;
  }
  CheckTimeOpen(){
    return !!this.model.StoreNo && !!this.model.PetNo && !!this.model.ReserveItems 
    && this.model.ReserveItems.length>0 && !!this.model.ResDate && this.ErrorMsg_openTime == '';
  }

  CheckSign(){
    return this.isScrollBottom && !this.pad.isEmpty();
  }
  //#endregion

  /**
   * 處理錯誤彈窗
   * @param msg 錯誤訊息內容
   * @param isFatal 是否為嚴重錯誤（如果是，關閉彈窗後導回首頁）
   */
  private handleError(msg: string, isFatal: boolean = false): void {
    Swal.fire({
      icon: 'error',
      title: '抱歉，發生錯誤',
      text: msg,
      confirmButtonText: '確定',
      confirmButtonColor: '#d33', // 習慣上錯誤用紅色
      allowOutsideClick: !isFatal // 嚴重錯誤不允許點擊外面關閉
    }).then((result) => {
      if (isFatal && result.isConfirmed) {
        // 導回首頁，並帶上必要的參數以免 LIFF 失效
        this.router.navigate(['/'], { 
          queryParams: { 
            CompanyID: this.CompanyID, 
            UserID: this.UserID, 
            Liff_ID: this.Liff_ID 
          } 
        });
      }
    });
  }
  ngOnDestroy() {
    this.subscribes.unsubscribe();
  }
}
